import React from 'react';
import { FileUpload } from './ui';

const TestFileUpload: React.FC = () => {
  const handleFileSelect = (file: File | null) => {
    console.log('Archivo seleccionado:', file);
  };

  const handleFileUpload = async (file: File): Promise<string> => {
    console.log('Subiendo archivo:', file.name);
    // Simular subida
    return `/uploads/test/${file.name}`;
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4 text-center">Prueba de Subida de Archivos</h2>
      <FileUpload
        onFileSelect={handleFileSelect}
        onFileUpload={handleFileUpload}
        accept="image/*,.pdf"
        maxSize={5}
      />
    </div>
  );
};

export default TestFileUpload;